import {createSelector} from 'reselect'
import {AppState} from 'redux/config'
import {Status, UrlSelection} from 'commonTypes'
import {
  getConfigurationOptionSelectValue,
  getUrlSelectValue,
  GroupedSelectorOptionType,
  ConfigurationSelectorOptionType,
} from 'helpers/common'
import createCachedSelector from 're-reselect'
import {ConfigurationOptionType} from 'graphql-api'
export const select_databases = (state: AppState) => state.databases.databases
export const select_databaseDetails = (state: AppState) => state.databases.database
export const select_databaseIdToCopy = (state: AppState) => state.databases.databaseIdToCopy
export const select_status = (state: AppState) => state.databases.status
export const select_statusDetails = (state: AppState) => state.databases.statusDetails
export const select_currentLegionFeatureFlags = (state: AppState) => state.databases.currentLegionFeatureFlags
export const select_allLegionFeatureFlags = (state: AppState) => state.databases.currentLegionFeatureFlags.flags
export const select_error = (state: AppState) => state.databases.error
export const select_gridSession = (state: AppState) => state.databases.gridSession
export const select_gridSession_pageSizeOptions = (state: AppState) => state.databases.gridSession.pageSizeOptions
export const select_databases_showDetails = (state: AppState) => state.databases.showDetails
export const select_showBulkEditPanel = (state: AppState) => state.databases.showBulkEditPanel
export const select_configuration_value = (state: AppState) => state.databases.configurationValue
export const select_configuration_enabled = (state: AppState) => state.databases.configurationEnabled
export const select_gridSession_filters = (state: AppState) => state.databases.gridSession.filters
export const select_gridSession_filters_searchQuery = (state: AppState) => state.databases.gridSession.filters.searchQuery
export const select_currentLegionCustomConfigOverrides = (state: AppState) => state.databases.currentLegionCustomConfigOverrides
export const select_urlOption = (state: AppState) => state.databases.urlOption
export const select_configurationOption = (state: AppState) => state.databases.configurationOption
export const select_specifiedUrls = (state: AppState) => state.databases.specifiedUrls

export const select_status_isPending = createSelector(
  select_status,
  status => status === Status.PENDING
)

export const select_databases_databaseEnabled = createCachedSelector(
  select_databases,
  (state: AppState, rowIndex: number) => rowIndex,
  (databases, rowIndex: number): boolean => {
    return !!databases[rowIndex]?.enabled
  })(
  (state: AppState, rowIndex: number) => rowIndex
)

export const select_jobTypeOptionsStatus = (state: AppState) => state.databases.jobTypeOptions.status

export const select_jobTypeOptionsError = (state: AppState) => state.databases.jobTypeOptions.error

export const select_jobTypeOptions = (state: AppState) => state.databases.jobTypeOptions.options

export const select_configurationOptions = (state: AppState) => state.databases.configurationOptions.options

export const select_bulkEdit = createSelector(
  select_configurationOptions,
  select_configurationOption,
  select_urlOption,
  select_configuration_value,
  select_configuration_enabled,
  select_specifiedUrls,
  (
    allConfigurationOptions,
    selectedConfigurationOption,
    selectedUrlOption,
    configurationValue,
    configurationEnabled,
    specifiedUrls
  ) => {
    const urlOption = getUrlSelectValue(selectedUrlOption.value, selectedUrlOption.label)
    const configurationOptions = [] as GroupedSelectorOptionType[]
    const distinctGroups = [...new Set(allConfigurationOptions.map(option => option.groupName))]

    distinctGroups.forEach(groupName => (
      configurationOptions.push({
        label: groupName,
        options: allConfigurationOptions.filter(option => option.groupName === groupName).map(item => ({
          label: item.label,
          subLabel: item.tag,
          value: item.tag,
          type: item.type,
        } as ConfigurationSelectorOptionType)),
      })
    ))

    const configurationOption = getConfigurationOptionSelectValue(selectedConfigurationOption.value, selectedConfigurationOption.label, selectedConfigurationOption.type)
    const submitButtonEnabled = configurationOption !== null && urlOption !== null &&
    (urlOption.value !== UrlSelection.MULTIPLE || specifiedUrls.length > 0) &&
    (configurationOption.type === ConfigurationOptionType.Boolean || configurationValue.length > 0)

    return {
      configurationOptions,
      configurationOption,
      urlOption,
      submitButtonEnabled,
      configurationValue,
      configurationEnabled,
      specifiedUrls,
      defaultMenuIsOpen: false,
    }
  }
)
